const mapOriginCountryFromApi = (
    { fulfillmentCenterId: id, country: name, countryISO }) => ({ id, name, countryISO })

const mapOriginCountriesFromApi = (originCountries) => {
  return { options: originCountries.map(mapOriginCountryFromApi) }
}

export default {
  mapOriginCountriesFromApi
}
